<template>
  <div class="admin-data-report-status">
    <Loading />
    <p>Gerando relátorio dos dias ({{counterPercentage}})</p>
  </div>
</template>

<script>
import Loading from "@components/generic/Loading.vue";

export default {
  components: {
    Loading,
  },

  props: {
    status: {
      type: Object,
    },
  },

  data() {
    return {};
  },

  mixins: [],

  methods: {},

  computed: {
    counter() {
      return `${this.status.currentCount} / ${this.status.count}`;
    },
    counterPercentage() {
      return `${((this.status.currentCount / this.status.count) * 100).toFixed(
        0
      )}%`;
    },
  },

  mounted() {},

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.admin-data-report-status {
  background: white;
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
  padding: 20px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  display: flex;

  .loading {
    margin-right: 10px;
  }

  p {
    margin: 0;
  }
}
</style>
